import { cn } from '../../../shared/utils/cn'
import { SELF_TEST_OUTCOME_CLASSES, SELF_TEST_OUTCOME_LABELS } from '../../../constants/selfTest'
import type { SelfTestOutcome } from '../../../types/selfTest'

interface SelfTestOutcomeBadgeProps {
  outcome: SelfTestOutcome
  className?: string
}

export function SelfTestOutcomeBadge({ outcome, className }: SelfTestOutcomeBadgeProps) {
  return (
    <span
      className={cn(
        'inline-block rounded px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        SELF_TEST_OUTCOME_CLASSES[outcome],
        className
      )}
    >
      {SELF_TEST_OUTCOME_LABELS[outcome]}
    </span>
  )
}
